import React, { useEffect, useState } from 'react';

export interface ShowHintProps {
  message: string;
  visible: boolean;
  onClose: () => void;
  duration?: number; // 显示时长，默认3秒
  position?: 'top' | 'bottom' | 'center'; // 位置，默认top
}

const ShowHint: React.FC<ShowHintProps> = ({ 
  message, 
  visible, 
  onClose, 
  duration = 3000,
  position = 'top'
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          onClose();
        }, 300); // 等待淡出动画完成
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [visible, duration, onClose]);

  if (!visible && !isVisible) return null;

  const getPositionStyle = () => {
    switch (position) {
      case 'bottom':
        return {
          bottom: '20px',
          top: 'auto'
        };
      case 'center':
        return {
          top: '50%',
          transform: 'translateY(-50%)'
        };
      default:
        return {
          top: '20px'
        };
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        transform: position === 'center' ? 'translateX(-50%) translateY(-50%)' : 'translateX(-50%)',
        zIndex: 9999,
        ...getPositionStyle()
      }}
    >
      <div
        style={{
          background: 'rgba(0, 0, 0, 0.8)',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: 400,
          whiteSpace: 'nowrap',
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }}
      >
        {message}
      </div>
    </div>
  );
};

export default ShowHint; 